module.exports = __webpack_public_path__ + "static/media/dr_julie_nos_400_400.01199a03.jpg";